<template>
    <div class="Inner Companies NoContent">
        <div class="Headline">
            <h1>Companies</h1>
        </div>
        <div v-if="!getUserCompanies.length" class="NoContentBox">
            <div>
                <h2>No companies yet...</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                <router-link disabled to="#" class="Button Green">
                    <simple-svg
                        :filepath="'images/SVG/Buttons/PlusCircle.svg'"
                        :width="'20px'"
                        :height="'20px'"
                    />
                    Add company
                </router-link>
            </div>
        </div>
        <div v-else>
            <ul v-for="company in getUserCompanies">
                <li>
                    {{company.company_name}}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import createEntity from "../../mixins/create-entity";
    export default {
        mixins: [createEntity],
        computed: {
            ...mapGetters([
                'getUserCompanies'
            ])
        }
    }
</script>
<style>
</style>
